import { useLingui } from '@lingui/react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CustomerComment(_ref) {
  let {
    title
  } = _ref;
  const {
    i18n: _i18n
  } = useLingui();
  return /*#__PURE__*/_jsxs("div", {
    className: "banner-return-customer__customer-comment",
    children: [/*#__PURE__*/_jsx("p", {
      className: "banner-return-customer__customer-comment-title",
      children: title
    }), /*#__PURE__*/_jsx("p", {
      className: "banner-return-customer__customer-comment-comment",
      children: _i18n._('carleadCreation.returningCustomerBanner.customerComment')
    }), /*#__PURE__*/_jsx("p", {
      className: "banner-return-customer__customer-comment-name",
      children: _i18n._('carleadCreation.returningCustomerBanner.customerCommentAuthor')
    })]
  });
}